import { G } from '@mobily/ts-belt'
import * as Sentry from '@sentry/vue'

import { stringify } from '@repo/utils'

export const reportError = (error: unknown, message: string, data?: Record<string, unknown>) => {
  Sentry.captureException(error, {
    extra: { data: G.isObject(data) ? stringify(data) : data, message },
  })
}
